import * as React from "react";
import { getPrintDate, handleYesNoShipment } from "../detail/form_utility";
import { SectionWrapper } from "./index";
import { IRootState } from "../../reducers";
import { connect } from "react-redux";

class ShipmentformPreviewComponent extends React.Component<any, any> {
  public render() {
    const { values } = this.props.mainForm.mainForm;
    return (
      <SectionWrapper className="extra-margin-top">
        <div className="PrintSectionHeader">Shipment</div>
       
        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">Description of loss:</div>
            <div className="PrintCommentValue">
                    {values.shipments[0].description}
            </div>
          </div>
        </div>

        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Any signs of tampering:</div>
            <div className="PrintItemValue">
              {handleYesNoShipment(values.shipments[0].tampering)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Was container seal intact:</div>
            <div className="PrintItemValue">
              {handleYesNoShipment(values.shipments[0].sealIntact)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Was packing intact:</div>
            <div className="PrintItemValue">
              {handleYesNoShipment(values.shipments[0].packingIntact)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Container No(s):</div>
            <div className="PrintItemValue">
              {values.shipments[0].containerNo}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Seal No(s):</div>
            <div className="PrintItemValue">{values.shipments[0].sealNo}</div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Date received in country:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].dateReceivedInCountry)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Damage/Missing/Short shipped quantity:
            </div>
            <div className="PrintItemValue">{values.shipments[0].quantity}</div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Customs clearance date:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].customsClearanceDate)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Forwarder refrence:</div>
            <div className="PrintItemValue">
              {values.shipments[0].forwarderReference}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Sales order no:</div>
            <div className="PrintItemValue">
              {values.shipments[0].salesOrderNo}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Sales order no:</div>
            <div className="PrintItemValue">
              {values.shipments[0].salesOrderNo}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Freight forwarder name:</div>
            <div className="PrintItemValue">
              {values.shipments[0].freightForwarderName}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Actual/Estimated freight value:
            </div>
            <div className="PrintItemValue">
              {values.shipments[0].actualFreightValue}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Shipment value:</div>
            <div className="PrintItemValue">
              {values.shipments[0].shipmentValue}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">B/L date:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].bldate)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">B/L, Waybill No's, AWB:</div>
            <div className="PrintItemValue">
              {values.shipments[0].blwayBillAwb}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Vessel ID/Flight No:</div>
            <div className="PrintItemValue">
              {values.shipments[0].vesselIdflightNo}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Means of transport:</div>
            <div className="PrintItemValue">
              {values.shipments[0].meansOfTransport}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Transport departure country:</div>
            <div className="PrintItemValue">
              {values.shipments[0].transportDepartureCountry}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Port/Airport of departure:</div>
            <div className="PrintItemValue">
              {values.shipments[0].portAirportOfDeparture}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Transport destination country:</div>
            <div className="PrintItemValue">
              {values.shipments[0].transportDestinationCountry}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Port/Airport of destination:</div>
            <div className="PrintItemValue">
              {values.shipments[0].originIncoterm}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Origin INCOTERM:</div>
            <div className="PrintItemValue">
              {values.shipments[0].originIncoterm}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Destination INCOTERM:</div>
            <div className="PrintItemValue">
              {values.shipments[0].destinationIncoterm}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Transport start:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].transportStart)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Transport end:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].transportEnd)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Shipment total quantity:</div>
            <div className="PrintItemValue">
              {values.shipments[0].shipmentTotalQuantity}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Insurance posting reference:</div>
            <div className="PrintItemValue">
              {values.shipments[0].insurancePostingReference}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Reported on:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.shipments[0].reportedOn)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Total number of packages:</div>
            <div className="PrintItemValue">
              {values.shipments[0].totalNumberOfPackages}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Actual/Estimated insured values:
            </div>
            <div className="PrintItemValue">
              {values.shipments[0].actualInsuredValuesCurrency}
              {values.shipments[0].actualInsuredValues}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Premium:</div>
            <div className="PrintItemValue">
              {values.shipments[0].premiumCurrency}
              {values.shipments[0].premium}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Quantity lost per material level:
            </div>
            <div className="PrintItemValue">
              {values.shipments[0].quantityLostPerMaterialLevel}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Total claims value supplies:</div>
            <div className="PrintItemValue">
              {values.shipments[0].totalClaimsValuesSuppliesCurrency}
              {values.shipments[0].totalClaimsValuesSupplies}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Claims value freight:</div>
            <div className="PrintItemValue">
              {values.shipments[0].claimsValueFreightCurrency}
              {values.shipments[0].claimsValueFreight}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">10% uplift:</div>
            <div className="PrintItemValue">
              {values.shipments[0].upliftCurrency}
              {values.shipments[0].uplift}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Deductible under the policy:</div>
            <div className="PrintItemValue">
              {values.shipments[0].deductibleUnderThePolicyCurrency}
              {values.shipments[0].deductibleUnderThePolicy}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Total value of loss:</div>
            <div className="PrintItemValue">
              {values.shipments[0].totalValueOfLossCurrency}
              {values.shipments[0].totalValueOfLoss}
            </div>
          </div>
        </div>

        <div className="PrintContainerWrapper PsbMargin">
          <div className="PrintCommentContainer ">
            <div className="PrintCommentLabel">
              <input type="checkbox" name="pcb" />
              PSB - Confirm that for all cases of shortage/loss/damage the
              records in Vision has been adjusted and the items are moved to the
              PSB bin (099) in Vision.
            </div>
            <div className="PrintCommentValue"></div>
          </div>
        </div>

        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">If No please comment</div>
            <div className="PrintCommentValue">
              {values.shipments[0].psbcomments}
            </div>
          </div>
        </div>

        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">Recovery value</div>
            <div className="PrintCommentValue">
              {values.shipments[0].recoveryValue}
            </div>
          </div>
        </div>
      </SectionWrapper>
    );
  }
}

// export default ShipmentformPreviewComponent;

const mapStateToProps = (state: IRootState) => {
  return {
    mainForm: state.form,
  };
};

// connect the form wrapper to the state store
export default connect(mapStateToProps, null)(ShipmentformPreviewComponent);
